import ContentfulLink, { PlatformTypes } from './contentful/ContentfulLink'
import { ContentfulExperimentConfig } from './ContentfulExperimentConfig'

interface ILink {
  id: string
  navigationPath: string
  scrollToHash: string
  experimentConfig?: ContentfulExperimentConfig[]
  openInNewTab?: boolean | null
  applicablePlatforms?: PlatformTypes[] | null
  liveShowId?: string
  preserveQueryParams?: boolean | null
  /**
   * Contentful CTA behavior selector. Decides *how* a click is handled (e.g. B2B self-serve token
   * transfer) — never *where* the link points, which stays owned by `navigationPath` / `url`.
   */
  ctaType?: string | null
  /**
   * Raw `url` field straight from Contentful — preserved separately from the
   * resolved `navigationPath` because some web flows (e.g. Live Event CTAs)
   * carry their canonical destination here as a fully-qualified URL with
   * query parameters (`?showId=…`) that the slug-derived `navigationPath`
   * doesn't capture.
   */
  url?: string | null
  /** Authored label. The only human-readable name when a container renders the link with no CTA. */
  text?: string | null
}

class Link implements ILink {
  id: string
  navigationPath: string
  scrollToHash: string
  experimentConfig?: ContentfulExperimentConfig[]
  openInNewTab?: boolean | null
  applicablePlatforms?: PlatformTypes[] | null
  liveShowId?: string
  preserveQueryParams?: boolean | null
  ctaType?: string | null
  url?: string | null
  text?: string | null

  constructor({
    id,
    navigationPath,
    scrollToHash,
    experimentConfig,
    openInNewTab,
    applicablePlatforms,
    liveShowId,
    preserveQueryParams,
    ctaType,
    url,
    text,
  }: ILink) {
    this.id = id
    this.navigationPath = navigationPath
    this.scrollToHash = scrollToHash
    this.experimentConfig = experimentConfig
    this.openInNewTab = openInNewTab
    this.applicablePlatforms = applicablePlatforms
    this.liveShowId = liveShowId
    this.preserveQueryParams = preserveQueryParams
    this.ctaType = ctaType
    this.url = url
    this.text = text
    return {
      ...this,
    }
  }

  static fromContentful(contentfulLink: ContentfulLink) {
    return new Link({
      id: contentfulLink.id,
      navigationPath: ContentfulLink.getLinkPath(contentfulLink),
      scrollToHash: contentfulLink.scrollToHash,
      experimentConfig: contentfulLink.experimentConfig,
      openInNewTab: contentfulLink.openInNewTab,
      applicablePlatforms: contentfulLink.applicablePlatforms,
      liveShowId: contentfulLink.liveShowId,
      preserveQueryParams: contentfulLink.preserveQueryParams,
      ctaType: contentfulLink.ctaType,
      url: contentfulLink.url,
      text: contentfulLink.text,
    })
  }
}

export default Link
